import { useQuery } from '@tanstack/react-query';
import { getAnalysis } from '../api/beachvision';

/**
 * Fetches analysis; returns processing state when API responds 202.
 * @param {number|string} sessionId
 * @param {{ refetchWhileProcessingMs?: number }} [opts]
 */
export function useAnalysis(sessionId, opts = {}) {
  const interval = opts.refetchWhileProcessingMs ?? 4000;
  const enabled = opts.enabled ?? true;
  return useQuery({
    queryKey: ['beachvision', 'analysis', sessionId, interval],
    queryFn: () => getAnalysis(sessionId),
    enabled: Boolean(sessionId) && enabled,
    refetchInterval: (data) =>
      data && data.ok === false && data.processing ? interval : false,
  });
}

